import {ReactNode} from 'react';
import type {UseQueryResult} from '@tanstack/react-query';

interface Props<T> {
  query: UseQueryResult<T>;
  children: {
    success: (data: T) => ReactNode;
    error?: ReactNode;
    loading?: ReactNode;
  }
}

export function EvLoadingTanStackQuery<T>(props: Props<T>) {
  switch (props.query.status) {
    case 'success':
      return props.children.success(props.query.data);
    case 'error':
      return props.children.error;
    default:
      return props.children.loading;
  }
}
